import React, { useEffect } from "react";
import "./Playground.css";
import trampoline from "../../../assets/img/imagefile/imagefile/Indoor playground.png";
import playground from "../../../assets/gem_products/toddler.jpg";
import trampoline1 from "../../../assets/gem_products/SOFT PLAY.jpg";
import interactiveGame from "../../../assets/gem_products/roleplay.jpg";
import zipline from "../../../assets/gem_products/zipline.jpg";
import slides from "../../../assets/gem_products/slides.jpg";
import sandarea from "../../../assets/gem_products/SAND AREA.jpg";
import ballpool from "../../../assets/gem_products/ball pool.jpg";
import donutslide from "../../../assets/gem_products/donut slide.jpg";
import Dashboard from "../../../components/Dashboard";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
import WhatsappButton from "../../../components/WhatsappButton";

const Playground = () => {
  let description = (
    <>
    <h2 className="dashboard-content">We Global Entertainment Manufacturer, design high-quality Performance Trampolines for trampoline parks. Built with premium materials, they offer greater height, improved airtime, and ultimate control.</h2>
      
    </>
  );
  return (
    <div>
      <Helmet>
        <meta
          name="playground equipment company"
          content="GEM offers high-quality indoor commercial playgrounds 
designed for safety, fun, and durability.
 Perfect for businesses looking to provide an 
exciting play experience"
        />
      </Helmet>

      <Header />
      <Dashboard
        Breadcrumb={
          <div
            style={{
              backgroundColor: "",
              marginTop: "13%",
              marginLeft: "3%",
              borderRadius: "5px",
            }}
          >
            <Breadcrumb />
          </div>
        }
        title={"Indoor playground"}
        imageUrl={trampoline}
        description={description}
      />

        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
      <div className="product-container">
        <div className="product-row">
          <div className="product">
            <Link
              to="/IndoorPlayground/SoftPlay"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={trampoline1}
                alt="playground equipment manufacturers"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Soft Play</p>
            </Link>
          </div>

          <div className="product">
            <Link
              to="/IndoorPlayground/Toddler"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={playground}
                alt="playTurn on screen reader supportground equipment catalog"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Toddler</p>
            </Link>
          </div>
          <div className="product">
            <Link
              to="/IndoorPlayground/RolePlay"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={interactiveGame}
                alt="playground equipment suppliers"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p> Role Play</p>
            </Link>
          </div>
        </div>
        <div className="product-row">
          <div className="product">
            <Link
              to="/IndoorPlayground/CarTrack"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={interactiveGame}
                alt="commercial indoor playground equipment"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Car Track</p>
            </Link>
          </div>
          <div className="product">
            <Link
              to="/IndoorPlayground/Zipline"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={zipline}
                alt="playgrounds"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Zipline</p>
            </Link>
          </div>
          <div className="product">
            <Link
              to="/IndoorPlayground/Slide"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={slides}
                alt="indoor commercial playground"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Slides</p>
            </Link>
          </div>
        </div>

        <div className="product-row">
          <div className="product">
            <Link
              to="/IndoorPlayground/SandArea"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={sandarea}
                alt="highest quality trampoline"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p> Sand Area</p>
            </Link>
          </div>

          <div className="product">
            <Link
              to="/IndoorPlayground/BallPool"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={ballpool}
                alt="indoor commercial playground"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Ball Pool</p>
            </Link>
          </div>
          <div className="product">
            <Link
              to="/IndoorPlayground/DoughnutSlide"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={donutslide}
                alt="indoor playground"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Donut Slide</p>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Playground;
